import { FC } from 'react';
import AppFormControl from './AppFormControl';

import DateInput, {
  DateInputProps,
} from 'presentation/components/shared/fields/DateInput';

interface Props extends FormFieldProps, Omit<DateInputProps, 'name'> {}

const FormDateInput: FC<Props> = ({ label, helperText, ...props }) => {
  return (
    <AppFormControl name={props.name} label={label} helperText={helperText}>
      <DateInput {...props} />
    </AppFormControl>
  );
};

export default FormDateInput;
